import React, { forwardRef } from 'react'
import styled from 'styled-components'

const SIZE_MAP = { large: 25, medium: 14, small: 10 }
const CONTAINER_SIZE_MAP = { large: 31, medium: 24, small: 20 }

type PmkLogoIconProps = { fontSize?: string; [key: string]: unknown }

const PmkLogoIcon = forwardRef<HTMLSpanElement, PmkLogoIconProps>(({ fontSize = 'medium', ...props }, ref) => {
  const size = SIZE_MAP[fontSize] ?? SIZE_MAP.medium
  const containerSize = CONTAINER_SIZE_MAP[fontSize] ?? CONTAINER_SIZE_MAP.medium
  return (
    <S.IconContainer ref={ref} $size={containerSize} {...props}>
      <img src="/img/pmk-logo-only.png" alt="PMK" width={size} height={size} />
    </S.IconContainer>
  )
})

PmkLogoIcon.displayName = 'PmkLogoIcon'

export default PmkLogoIcon

const S = {
  IconContainer: styled.span.withConfig({
    shouldForwardProp: (prop) => !['$size'].includes(prop)
  })<{ $size: number }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: ${({ $size }) => $size}px;
    height: ${({ $size }) => $size}px;
    flex-shrink: 0;
  `
}
